export class Constants {
  //API PARA PRUEBAS LOCALES
  //static hostApiNode = "localhost:3000"
  //API PARA PRODUCCION
  static hostApiNode = "https://nodeapipupilometro.r1group.com.ar"//"http://apinodepupilscanner.r1group.co"
  static DRAG_OFFSET_Y =  56;
  static urlFotos = "https://nodeapipupilometro.r1group.com.ar/api/contenedors/";
  static urlEmpresa = "https://nodeapipupilometro.r1group.com.ar/api/ContenedorEmpresas/";
  //static HOST = '';
  // static HOST = '192.168.50.48:5000';
  // static HOST = '192.168.50.112:5000';
  //static HOST = '192.168.0.10:5000';
  //static TIMEOUT_UPLOADIMAGE: number = 15000;
  //static SCALE_FACTOR: number = 0.25;
  //static CROP_IMAGE_FACTOR: number = 0.5;
  
  //static BASE_URL = '';//'http://apinodepupilscanner.r1group.co';
  //static API_VERSION = 'api';
 


}



// WEBPACK FOOTER //
// ./src/constants.ts